var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.itemCollection)?_c('AppProgressBar',{staticClass:"checklist-percentage-bar",attrs:{"title":("Percentage of checklist items completed - " + _vm.getPercentileCompleted + "%"),"percentage":_vm.getPercentileCompleted}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }